import React, { useState, useRef } from 'react'
import { Link, styled } from '@mui/material'
import { Dropdown } from '..'

const centerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

const DropdownAnchor = styled('span')(({ anchorPosition }) => ({
    position: 'relative',
    ...anchorPosition,
}))

const PopupMenu = ({
    displayIcon,
    style,
    onOpen,
    onClose,
    handleItemSelection,
    menuHeight,
    children,
    anchorPosition,
    showCone = true,
    'aria-label': ariaLabel,
    'aria-expanded': ariaExpanded,
    'aria-haspopup': ariaHasPopup,
    ...rest
}) => {
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
        onClose && onClose()
    }

    return (
        <>
            <div style={{ position: 'relative', ...centerStyles, ...style }}>
                <Link
                    underline="none"
                    component="button"
                    onClick={() => {
                        onOpen && onOpen()
                        setOpen((prev) => !prev)
                    }}
                    aria-label={ariaLabel}
                    aria-expanded={ariaExpanded ?? open}
                    aria-haspopup={ariaHasPopup}
                    sx={{ ...centerStyles }}
                >
                    {displayIcon}
                </Link>
                <DropdownAnchor
                    ref={anchorRef}
                    anchorPosition={anchorPosition}
                />
            </div>

            <Dropdown
                open={open}
                anchorEl={anchorRef.current}
                handleClose={handleClose}
                showCone={showCone}
                menuHeight={menuHeight}
                {...rest}
            >
                {children}
            </Dropdown>
        </>
    )
}

export default PopupMenu
